module.exports = __webpack_public_path__ + "img/Menu-12.7f151282.png";